import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayout from "../layouts/footer.layout";
import banner from "../styles/images/banner_superior_productos.webp";
import ProductosComponent from "../components/productos/productos.component";
import { productos } from "../libs/productosV3";

const ProductosPage: React.FC = () => {
  const [categoriasData, setCategoriasData] = useState<any[]>([]);
  const [categorias] = useState([
    { title: "Tratamientos de agua y acueductos", media: "../banner_categorias/acueducto.webp" },
    { title: "Agroquímicos", media: "../banner_categorias/agroquimica.webp" },
    { title: "Alimentos", media: "../banner_categorias/alimentos.webp" },
    { title: "Avícola", media: "../banner_categorias/avicola.webp" },
    { title: "Curtiembres", media: "../banner_categorias/curtiembres.webp" },
    { title: "Farmacéutico", media: "../banner_categorias/farmaceutica.webp" },
    { title: "Laboratorio", media: "../banner_categorias/laboratorio.webp" },
    { title: "Limpieza", media: "../banner_categorias/limpieza.webp" },
    { title: "Petróleo", media: "../banner_categorias/petroleo.webp" },
    { title: "Piscinas recreativas", media: "../banner_categorias/piscina_recreativa.webp" },
    { title: "Porcícola", media: "../banner_categorias/porcicola.webp" },
    { title: "Todas las categorías", media: "../banner_categorias/todas_las_categorias.webp" },
  ]);

  useEffect(() => {
    const categoriasConProductos = categorias.map((categoria) => {
      const productosEnCategoria = productos.filter((producto: any) =>
        producto?.categorias?.includes(categoria.title)
      );

      return {
        title: categoria.title,
        media: categoria.media,
        productos: productosEnCategoria,
      };
    });
    
    setCategoriasData(categoriasConProductos);
  }, [categorias]); // Dependencia agregada

  return (
    <>
      <MenuLayouts />
      <div
        className="page-title-area"
        style={{
          backgroundImage: `URL(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="page-title-content">
            <h1 style={{ color: "#fff" }}>Productos</h1>
          </div>
        </div>
      </div>
      <ProductosComponent categoriasData={categoriasData} />
      <FooterLayout />
    </>
  );
};

export default ProductosPage;
